import { useEffect } from "react";
import * as React from "react";
import { Helmet } from "react-helmet";

import { BigScreenSignup } from "./big-screen";

import { setReferrerURL } from "utils/page-sense-events";

const SignUp: React.FC = (): JSX.Element => {
  const referrerURL = document.referrer;

  setReferrerURL(referrerURL);

  useEffect((): VoidFunction => {
    sessionStorage.setItem("trial", "true");

    return (): void => {
      sessionStorage.removeItem("trial");
    };
  }, []);

  return (
    <React.Fragment>
      <Helmet>
        <title>{"Sign up for a free trial | Fluid Attacks"}</title>
        <meta
          content={
            "Create your Fluid Attacks account with your work email and start a free trial of automated security testing for your applications."
          }
          name={"description"}
        />
        <link href={"https://app.fluidattacks.com/SignUp"} rel={"canonical"} />
      </Helmet>
      <BigScreenSignup />
    </React.Fragment>
  );
};

export { SignUp };
